import { convertIWireDepositResponseDataToIWireDepositData, IWireDepositResponse } from './IWireDepositResponse';
import { IEscrowFileCompleteData } from '../IEscrowFileCompleteData';
import { IEscrowBankAccountResponse } from '../../../accounting/response/IEscrowBankAccountResponse';
import { IOrderData } from '../../../accounting/data/IOrderData';
import {
  convertIManualCheckDisbursementResponseToIManualCheckDisbursementData,
  IManualCheckDisbursementResponse,
} from './IManualCheckDisbursementResponse';
import { IWireDisbursementResponse } from '../IEscrowWireDisbursementsData';
import { IInternalTransferResponse } from './IInternalTransferResponse';
import { convertICheckDepositResponseToICheckDepositData, ICheckDepositResponse } from '../ICheckDeposit';
import { IAchPushDisbursementResponse } from './IAchPushDisbursementResponse';
import {
  convertIAchPullDepositResponseToIAchPullDepositData,
  IAchPullDepositResponse,
} from './IAchPullDepositResponse';
import { ICDItemData } from '../ICDitemsData';
import { ISODateString } from '../../../shared/ISODateString';
import { ICheckDisbursementResponse } from './ICheckDisbursementResponse';
import { IOldTransactionResponse } from './IOldTransactionResponse';

export interface IEscrowFileCompleteResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  fundedAt?: ISODateString | null;
  order: IOrderData;
  depositEscrowBankAccount: IEscrowBankAccountResponse;
  expectedIncomingWireResponse?: IWireDepositResponse[];
  expectedIncomingCheckResponse?: ICheckDepositResponse[];
  achPullDepositResponse?: IAchPullDepositResponse[];
  internalTransferResponse?: IInternalTransferResponse[];
  unrestrictedInternalTransferResponse?: IInternalTransferResponse[];
  wireDisbursementResponse?: IWireDisbursementResponse[];
  manualCheckDisbursementResponse?: IManualCheckDisbursementResponse[];
  achPushDisbursementResponse?: IAchPushDisbursementResponse[];
  cdItemsResponse?: ICDItemData[];
  oldTransactionResponse?: IOldTransactionResponse[];
  checkDisbursementResponse?: ICheckDisbursementResponse[];
}

export const convertIEscrowFileCompleteResponseDataToIEscrowFileData = ({
  id,
  createdAt,
  updatedAt,
  fundedAt,
  depositEscrowBankAccount,
  expectedIncomingWireResponse,
  expectedIncomingCheckResponse,
  achPullDepositResponse,
  internalTransferResponse,
  unrestrictedInternalTransferResponse,
  wireDisbursementResponse,
  manualCheckDisbursementResponse,
  achPushDisbursementResponse,
  cdItemsResponse,
  oldTransactionResponse,
  checkDisbursementResponse,
}: IEscrowFileCompleteResponse): IEscrowFileCompleteData => ({
  id,
  createdAt,
  updatedAt,
  fundedAt,
  depositEscrowBankAccount,
  wireDeposits: expectedIncomingWireResponse?.map((wire) =>
    convertIWireDepositResponseDataToIWireDepositData(depositEscrowBankAccount, wire)
  ),
  wireDisbursements: wireDisbursementResponse,
  manualCheckDisbursements: manualCheckDisbursementResponse?.map(
    convertIManualCheckDisbursementResponseToIManualCheckDisbursementData
  ),
  restrictedInternalTransfers: internalTransferResponse,
  unrestrictedInternalTransfers: unrestrictedInternalTransferResponse,
  achPushDisbursements: achPushDisbursementResponse,
  checkDeposits: expectedIncomingCheckResponse?.map((check) => convertICheckDepositResponseToICheckDepositData(check)),
  achPullDeposits: achPullDepositResponse?.map((ach) => convertIAchPullDepositResponseToIAchPullDepositData(ach)),
  cdItemsResponse,
  oldTransactions: oldTransactionResponse,
  checkDisbursements: checkDisbursementResponse,
});
